import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '@env/environment';
import numberToWords from 'number-to-words';
import {RouterLink} from '@angular/router';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {FilterPipe, Nl2BrPipe} from '@app/shared/pipe';
import {UtilsInjectable} from '@app/shared';
import { ReportPdfComponent } from '@app/components/report-pdf/report-pdf.component';
import * as XLSX from 'xlsx';

const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-stock-report',
  templateUrl: './stock-report.component.html',
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    PageHeaderComponent,
    FilterPipe,
    Nl2BrPipe,
    NgOptimizedImage,
    ReportPdfComponent
  ],
  styleUrls: ['./stock-report.component.scss']
})
export class StockReportComponent implements OnInit {
  @ViewChild('table') table?: ElementRef;
  user_rights: any;
  user_data: any;

  stock_data: any = [];
  closeResult = "";
  purchase_list: any;
  public sales_return_list: any = [];
  public sales_list: any = [];
  public purchase_return_list: any = [];
  medicine: any;
  medicine_id: any;

  purchase_quantity = 0;
  purchase_return_qty = 0;
  sale_return_quantity: any;
  sale_quantity = 0;
  sale_price = 0;
  cost_price = 0;
  saled: any;
  item_list: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  vat_list: any;
  total_vat = 0;
  total_flood = 0;
  save_rate = 0;
  gross = 0;
  price_total = 0;
  numberToWords: any;
  search_by_date: any;
  purchased: any;
  net_total = 0;
  disc_total = 0;
  margin = 0;
  vat_credit = 0;
  damage_list: any;
  damage_quantity = 0;
  warehouse_list: any;
  warehouse_list_quantity = 0;
  term = "";

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public rest: ConsultingService,
              public report: ReportService,
              protected utils: UtilsInjectable
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listStockReport();
  }

  public listStockReport() {
    const postData = {
      to_date: this.search_by_date
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.listStockReport(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.stock_data = result['data'];
        for (const data of this.stock_data) {
          data['AVAILABLE'] = (parseInt(data.QUANTITY) - parseInt(data.RETURN_QUANTITY) - parseInt(data.SALE_QUANTITY) - parseInt(data.DAMAGE_QUANTITY)) + parseInt(data.SALE_RETURN_QUANTITY)
        }
        this.loaderService.display(false);
      } else {
        this.stock_data = []
        this.loaderService.display(false);
      }
    });
  }

  public purached_items(item: any) {

    const postData = {

      purchase_id: item.PURCHASE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.getPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchased = result['data'];
        this.item_list = result['data'].PURCHASE;
        this.getSumpurchase();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  getSumpurchase() {
    let price = 0;
    let disc = 0;

    for (const item of this.item_list) {
      price = price + parseFloat(item.GROSS_AMOUNT);
      disc = disc + parseFloat(item.DISCOUNT);
    }
    this.price_total = price
    if (this.purchased.DISCOUNT) {
      this.net_total = price - this.purchased.DISCOUNT
    } else {
      this.net_total = price
    }
    this.disc_total = disc
  }

  getSum() {
    let total = 0;
    let save = 0;
    for (const item of this.item_list) {
      total = total + parseFloat(item.TOTAL);
      save = save + parseFloat(item.SAVE_RATE);
    }
    this.save_rate = Math.round(save);
    this.gross = total
    if (this.saled) {

      this.price_total = Math.round((this.gross - parseFloat(this.saled.DISCOUNT)) + parseFloat(this.saled.FREIGHT_CHARGE))
    } else {
      this.price_total = Math.round(this.gross)
    }
    this.numberToWords = (numberToWords.toWords(this.price_total));
  }

  public getVatValue() {
    const postData = {

      sale_id: this.saled.SALE_ID,
      state_code: this.saled.TIN_NUMBER
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.getVatValue(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.vat_list = result['data'];
        let total_vat = 0;
        let total_flood = 0;
        for (const vat of this.vat_list) {
          total_vat = total_vat + parseFloat(vat.VAT_VALUE)
          total_flood = total_flood + parseFloat(vat.FLOOD_CESS)
        }

        this.total_vat = (total_vat)
        this.total_flood = (total_flood)
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public purchaseItemDetails(item: any) {
    const postData = {
      medicine_id: item.MEDICINE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.purchaseItemDetails(postData).subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.medicine = item.TRADE_NAME
        this.purchase_list = result['data'];
        this.getQuantity();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public purchaseReturnItemDetails(item: any) {
    const postData = {

      medicine_id: item.MEDICINE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.purchaseReturnItemDetails(postData).subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.medicine = item.TRADE_NAME
        this.purchase_return_list = result['data'];
        this.getQuantity();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public salesItemDetails(item: any) {
    const postData = {
      medicine_id: item.MEDICINE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.salesItemDetails(postData).subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.medicine = item.TRADE_NAME
        this.sales_list = result['data'];
        this.getQuantity();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public salesReturnItemDetails(item: any) {
    const postData = {
      medicine_id: item.MEDICINE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.salesReturnItemDetails(postData).subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.medicine = item.TRADE_NAME
        this.sales_return_list = result['data'];
        this.getQuantity();


        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public DamagedItemDetails(item: any) {
    const postData = {
      medicine_id: item.MEDICINE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.DamagedItemDetails(postData).subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.medicine = item.TRADE_NAME
        this.damage_list = result['data'];
        this.getQuantity();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public StockItemDetails(item: any) {
    if (item.AVAILABLE != 0) {
      const postData = {
        medicine_id: item.MEDICINE_ID
      };
      this.loaderService.display(true);
      this.report.StockItemDetails(postData).subscribe((result: any) => {
        if (result['status'] == 'success') {
          this.medicine = item.TRADE_NAME
          this.medicine_id = item.MEDICINE_ID
          this.warehouse_list = result['data'];
          this.warehouse_list_quantity = this.warehouse_list.reduce((sum: any, current: any) => sum + parseInt(current.WAREHOSE_AVAILABLE_QUANTITY), 0)
          this.loaderService.display(false);
        } else {
          this.loaderService.display(false);
        }
      });
    }

  }

  getQuantity() {
    let sale_quantity = 0;
    let sale_price = 0;
    let cost_price = 0;
    let margin = 0;
    let vat_credit = 0;
    let purchase_return_qty = 0;
    let purchase_quantity = 0;
    let sale_return_quantity = 0;
    let damage_quantity = 0;
    if (this.purchase_list) {
      for (const item of this.purchase_list) {
        purchase_quantity = purchase_quantity + parseInt(item.QUANTITY)
      }
    }
    if (this.purchase_return_list) {
      for (const item of this.purchase_return_list) {
        purchase_return_qty = purchase_return_qty + parseInt(item.RETURN_QUANTITY)
      }
    }
    if (this.sales_list) {
      for (const item of this.sales_list) {
        sale_quantity = sale_quantity + parseInt(item.QUANTITY)
        sale_price = sale_price + parseFloat(item.SALE_PRICE)
        cost_price = cost_price + parseFloat(item.COST_PRICE)
        vat_credit = vat_credit + parseFloat(item.VAT_CREDIT)
        margin = margin + (parseFloat(item.SALE_PRICE) - parseFloat(item.COST_PRICE))
      }
    }
    if (this.sales_return_list) {
      for (const item of this.sales_return_list) {
        sale_return_quantity = sale_return_quantity + parseInt(item.QUANTITY)
      }
    }
    if (this.damage_list) {
      for (const item of this.damage_list) {
        damage_quantity = damage_quantity + parseInt(item.DAMAGE_QUANTITY)
      }
    }
    this.purchase_quantity = purchase_quantity
    this.purchase_return_qty = purchase_return_qty
    this.sale_quantity = sale_quantity
    this.sale_price = sale_price
    this.cost_price = cost_price
    this.vat_credit = vat_credit
    this.margin = margin
    this.sale_return_quantity = sale_return_quantity
    this.damage_quantity = damage_quantity
  }

  public sale_items(item: any) {
    const postData = {
      sale_id: item
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.getSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.item_list = result['data'].SALE;
        let i = 0;
        for (const data of this.item_list) {

          const unit = parseFloat(data.UNIT_PRICE);
          const vat = parseFloat(data.VAT);
          if (this.saled && this.saled.TIN_NUMBER == 32) {
            data["BASE_PRICE"] = ((unit / (environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          if (this.saled && this.saled.TIN_NUMBER != 32) {
            data["BASE_PRICE"] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          this.item_list[i] = data;
          i = i + 1;
        }
        this.getVatValue();
        this.getSum();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  protected open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: " col-md-12",
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected opens(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public ExportToExcel() {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table?.nativeElement, {
        dateNF: 'dd/mm/yyyy;@',
        cellDates: true,
        raw: true
      });
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      /* save to file */
      XLSX.writeFile(wb, 'Stock_report' + new Date().getTime() + EXCEL_EXTENSION);
  
  }
}
